import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useToken } from '../../store/slices/authSlice';
import { useLoginUserType } from '../../store/slices/commonSlice';

const AuthLayout = () => {
  const token = useToken();
  const loginUserType = useLoginUserType();

  if (token) {
    return (
      <Navigate
        to={
          loginUserType === 'tenant'
            ? '/tenant-dashboard'
            : loginUserType === 'MasterAdmin'
              ? '/admin-dashboard'
              : '/dashboard'
        }
        replace
      />
    );
  }

  return <Outlet />;
};

export default AuthLayout;
